import React, { FC, useEffect } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePageStore } from "@/hooks/usePageStore";
import Breadcrumbs from "@/components/Breadcrumbs";
import RequireAction from "@/components/RequireAction";
import { ActionCodeEnum } from "@/domain/action.enum";
import ParticipantTimeline from "@/ui/content/troubleshooting/ParticipantTimeline";

/**
 * COYN-1507: "Participant timeline" troubleshooting screen.
 * Route: /troubleshooting/timeline, granted by the PART_TIMELINE_VIEW action.
 */
const ParticipantTimelinePage: FC = () => {
  const { t } = useTranslation("troubleshooting");
  const { setPageTitle } = usePageStore();

  useEffect(() => {
    setPageTitle(t("pageTitle"));
  }, [setPageTitle, t]);

  return (
    <RequireAction code={ActionCodeEnum.PART_TIMELINE_VIEW}>
      <Box>
        <Breadcrumbs
          items={[
            { label: t("breadcrumb"), isLink: false },
            { label: t("pageTitle"), isLink: false },
          ]}
        />
        <Box sx={{ mt: 2 }}>
          <ParticipantTimeline />
        </Box>
      </Box>
    </RequireAction>
  );
};

export default ParticipantTimelinePage;
